import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_NEW_USER_COUNT_QUERY_KEY } from "../types/CommonTypes";
import { NEW_USER_COUNT_RESPONSE } from "../types/ResponseTypes";

async function getNewUserCount(params?: {
  tenantId?: string;
  hospitalId?: string;
}): Promise<NEW_USER_COUNT_RESPONSE> {
  const { tenantId, hospitalId } = params ?? {};
  const { data } = await fetcher({
    url: "/users/new-user-count",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetNewUserCountQuery(
  params?: { tenantId?: string; hospitalId?: string },
  options?: UseQueryOptions<NEW_USER_COUNT_RESPONSE, Error>
) {
  const { tenantId, hospitalId } = params ?? {};
  return useQuery<NEW_USER_COUNT_RESPONSE, Error>({
    queryKey: [GET_NEW_USER_COUNT_QUERY_KEY, tenantId, hospitalId],
    queryFn: () => getNewUserCount(params),
    ...options,
  });
}

export default useGetNewUserCountQuery; 